import type { ActionReducerMapBuilder, AsyncThunk, PayloadAction } from '@reduxjs/toolkit'

import type { UploadedFile } from '../../types'

export function loadingStatusExtraReducers<ThunkArg, ThunkReturn = void>(
  builder: ActionReducerMapBuilder<UploadedFile[]>,
  thunk: AsyncThunk<ThunkReturn, ThunkArg, Record<string, unknown>>,
  getFileName?: (
    action: PayloadAction<
      unknown,
      string,
      {
        arg?: ThunkArg
        requestId: string
        requestStatus: 'pending' | 'fulfilled' | 'rejected'
      }
    >,
  ) => string,
): void {
  builder
    .addCase(thunk.pending, (state, action) => {
      const entity = state.filter(state => state.name === getFileName?.(action)).at(-1)
      if (entity) {
        entity.status = 'loading'
      }
    })
    .addCase(thunk.fulfilled, (state, action) => {
      const entity = state.filter(state => state.name === getFileName?.(action)).at(-1)
      if (entity) {
        entity.status = 'succeeded'
      }
    })
    .addCase(thunk.rejected, (state, action) => {
      const entity = state.filter(state => state.name === getFileName?.(action)).at(-1)
      if (entity) {
        entity.status = 'failed'
      }
    })
}
